/** The text MUI components render themselves, in the UI language.
 *
 *  Autocomplete ("No options", the clear/open/close buttons), the Alert
 *  close button and the Breadcrumbs expander carry built-in English.
 *  MUI ships locale packs, but not for every language we offer (none
 *  for lt, lv or sw) and only as one ~130 KB index, so the SPA owns
 *  these strings as mui.* keys instead: seeded from MUI's pack where
 *  one exists (the registry's ``mui`` field), translated like any other
 *  key where not. createAppTheme() puts them into the component
 *  defaults; a component's own prop still wins. */
export interface MuiText {
  autocompleteClear: string;
  autocompleteClose: string;
  autocompleteOpen: string;
  autocompleteLoading: string;
  autocompleteNoOptions: string;
  alertClose: string;
  breadcrumbsExpand: string;
}

export function muiText(t: (key: string) => string): MuiText {
  return {
    autocompleteClear: t("mui.autocomplete.clear"),
    autocompleteClose: t("mui.autocomplete.close"),
    autocompleteOpen: t("mui.autocomplete.open"),
    autocompleteLoading: t("mui.autocomplete.loading"),
    autocompleteNoOptions: t("mui.autocomplete.no_options"),
    alertClose: t("mui.alert.close"),
    breadcrumbsExpand: t("mui.breadcrumbs.expand"),
  };
}
